import React from "react";
import { Mode, ThemeProvider } from "@ucl/context";
import { dseThemeSet } from "@ucl/styles/themes/designSystem/dse/themeSet";

export function UclThemeProvider({ children }: { children: React.ReactNode }) {
    return (
        <ThemeProvider
            themeSet={dseThemeSet}
            mode={Mode.LIGHT_MODE}
            productTeamName="Pre Qualification"
            disableAnalytics
        >
            {children}
        </ThemeProvider>
    );
}
